export default {
  exchangeInfo: { method: 'get', url: '/game-api/exchange/info' }, // 获取兑换配置信息
  exchangeOperate: { method: 'post', url: '/game-api/exchange/operate' }, // 执行兑换
  exchangeList: { method: 'get', url: '/game-api/exchange/list' }, // 兑换记录
  rechargeGetOrder: { method: 'post', url: '/game-api/recharge/getOrder' }, // 充值获取订单
  rechargeList: { method: 'get', url: '/game-api/recharge/list' } // 充值记录
}

